import React, { useState } from 'react';
import { AppBar, Tabs, Tab, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';
import RepresentativeSearch from './RepresentativeSearch';
import UserSearch from './UserSearch';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const CustomTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  flex:1,
  color: 'white', // Default text color
  '&.Mui-selected': {
    color: 'yellow', // Color of the selected tab text
  },
}));

const CustomLabel = ({ icon, text }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    {icon}
    <span style={{ marginLeft: '8px' }}>{text}</span>
  </div>
);

const SearchTabs = ({setRepId,setUserId}) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{  }}>
      <AppBar position="static" sx={{ backgroundColor: '#333' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="option selection"
          TabIndicatorProps={{ style: { backgroundColor: 'yellow' } }} // Indicator color
        >
          <CustomTab
            label={<CustomLabel icon={<span></span>} text="Representatives" />}
            {...a11yProps(0)}
          />
          <CustomTab
            label={<CustomLabel icon={<span></span>} text="Users" />}
            {...a11yProps(1)}
          />
          
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
          <RepresentativeSearch setRepId={setRepId}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
         <UserSearch setUserId={setUserId}/>
      </TabPanel>
      
    </Box>
  );
};

export default SearchTabs;
